import { format, parseISO, isValid } from 'date-fns'

let datePattern = 'dd/MM/yyyy'

/** Sets how dates are shown across the app (the workspace's setting). */
export function setDateFormat(pattern: string) {
  datePattern = pattern
}

export function formatDate(dateString: string | null | undefined): string {
  if (!dateString) return ''
  try {
    const date = parseISO(dateString)
    if (!isValid(date)) return dateString
    return format(date, datePattern)
  } catch {
    return dateString
  }
}

export function formatDateTime(dateString: string | null | undefined): string {
  if (!dateString) return ''
  try {
    const date = parseISO(dateString)
    if (!isValid(date)) return dateString
    return format(date, `${datePattern} h:mm a`)
  } catch {
    return dateString
  }
}

export function formatDateInput(dateString: string | null | undefined): string {
  if (!dateString) return ''
  try {
    const date = parseISO(dateString)
    if (!isValid(date)) return dateString
    return format(date, 'yyyy-MM-dd')
  } catch {
    return dateString
  }
}

export function parseDate(dateString: string): Date | null {
  try {
    const date = parseISO(dateString)
    return isValid(date) ? date : null
  } catch {
    return null
  }
}

export function toISODateString(date: Date): string {
  return format(date, 'yyyy-MM-dd')
}

export function getRelativeTime(dateString: string | null | undefined): string {
  if (!dateString) return ''
  try {
    const date = parseISO(dateString)
    if (!isValid(date)) return ''
    const now = new Date()
    const diff = now.getTime() - date.getTime()
    const seconds = Math.floor(diff / 1000)
    const minutes = Math.floor(seconds / 60)
    const hours = Math.floor(minutes / 60)
    const days = Math.floor(hours / 24)

    if (days > 0) return `${days}d ago`
    if (hours > 0) return `${hours}h ago`
    if (minutes > 0) return `${minutes}m ago`
    return 'Just now'
  } catch {
    return ''
  }
}

/** Parses a typed DD/MM/YYYY (or DD-MM-YYYY) date into yyyy-MM-dd; null when it is not a real date. */
export function parseDisplayDate(value: string): string | null {
  const match = /^(\d{2})[/-](\d{2})[/-](\d{4})$/.exec(value.trim())
  if (!match) return null
  const [, day, month, year] = match
  const date = new Date(Number(year), Number(month) - 1, Number(day))
  if (date.getFullYear() !== Number(year) || date.getMonth() !== Number(month) - 1 || date.getDate() !== Number(day)) {
    return null
  }
  return `${year}-${month}-${day}`
}
